export { default } from './ColorInput.js';
